import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ChatOpenRequest {
    conversationId?: string;
}

@Injectable({ providedIn: 'root' })
export class ChatUiService {
    private openSubject = new Subject<ChatOpenRequest>();
    public open$ = this.openSubject.asObservable();

    openChat(conversationId?: string): void {
        this.openSubject.next({ conversationId });
    }
}
